import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useSafetyRepWorkQuery } from '../../hooks/queries/safetyRep/useSafetyRepWork';
import { questionLanguageFor } from '../FormSubmission/workEnvironmentFormView';
import { NotificationsCard } from './components/NotificationsCard';
import { PreferencesCard } from './components/PreferencesCard';
import { RoleCard } from './components/RoleCard';
import { SafetyRepHero } from './components/SafetyRepHero';
import { TasksCard } from './components/TasksCard';
import { TeamsCard } from './components/TeamsCard';
import { WorkState } from './components/WorkState';
import layout from '../HRDashboard/hmsPage.module.css';

/** What waits for the safety representative, where their teams are, and what they have heard about */
export const SafetyRepOverview = (): ReactElement => {
  const { t, i18n } = useTranslation();
  const { data, isLoading } = useSafetyRepWorkQuery(
    questionLanguageFor(i18n.language),
  );

  return (
    <div className={layout.page} data-size="md">
      <SafetyRepHero
        title={t('safetyRep.work.overviewTitle')}
        intro={
          data &&
          t('safetyRep.work.intro', {
            count: data.teams.length,
            organization: data.organizationName,
          })
        }
      />
      {data ? (
        <div className={layout.layout}>
          <div className={layout.main}>
            <TasksCard tasks={data.tasks} />
            <TeamsCard teams={data.teams} tasks={data.tasks} />
            <NotificationsCard notifications={data.notifications} />
          </div>
          <div className={layout.side}>
            <PreferencesCard preferences={data.preferences} />
            <RoleCard />
          </div>
        </div>
      ) : (
        <WorkState loading={isLoading} error={t('safetyRep.work.error')} />
      )}
    </div>
  );
};
